"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisposableComplexDataError = exports.ComplexDataError = void 0;
// eslint-disable-next-line max-classes-per-file
const bluebird_1 = __importDefault(require("bluebird"));
const FilterBuilder = __importStar(require("@powerednow/shared/modules/utilities/filterBuilder"));
const ts_mixer_1 = require("ts-mixer");
const object_1 = require("@powerednow/shared/modules/utilities/object");
const decorators_1 = require("@powerednow/shared/modules/utilities/decorators");
const validationResult_1 = __importDefault(require("@powerednow/shared/modules/validation/validationResult"));
const exceptions = __importStar(require("@powerednow/errors"));
const baseData_1 = __importDefault(require("./baseData"));
const modelValidator_1 = __importDefault(require("./modelValidator"));
const connectedData_1 = __importDefault(require("./connectedData"));
const cache_1 = __importDefault(require("./cache"));
const entity_1 = require("./entity");
const uniqueIdStorage_1 = __importDefault(require("./uniqueIdStorage"));
const decorator_1 = require("./decorator");
const assiciationWalker_1 = __importDefault(require("./assiciationWalker"));
const _ = require('lodash');
const instanceSymbol = Symbol('instanceSymbol');
const itemIsInstantiatedSymbol = Symbol('itemIsInstantiated');
const constructorSymbol = Symbol('constructorSymbol');
const isNewSymbol = Symbol('isNewSymbol');
const isDeletedSymbol = Symbol('isDeletedSymbol');
const isUpdatedSymbol = Symbol('isUpdatedSymbol');
const skipDefaultsSymbol = Symbol('skipDefaults');
const valuesAsArrayKey = Symbol('valuesAsArrayKey');
/**
 * This is kinda a decorator, but actually it is not a real one.
 * The problem is the legacy decorator spec we depend on doesn't support getter/setter decorators.
 * The new proposed decorator spec is not compatible with the legacy one and far, far, _far_ less powerful.
 * What we do here basically is to create a lazy getter on the scope, grab the original getter reference and when called
 * we store the result from the original getter on the calling scope.
 *
 * It is important to scan through the prototype chain for getters, as we may override specific getters in a child,
 * but it is also important to ignore any of our memoized getters when searching for original getter, as we may
 * already cached it, before we created a new subclass, with different getter.
 *
 * @param scope
 * @param functionName
 */
const memoizeGetter = (scope, functionName) => {
    const originalGetter = (0, object_1.getGetterReference)(scope, functionName, reference => !reference.isMemoized);
    function get() {
        if (!Object.hasOwnProperty.call(this, `_original${functionName}`)) {
            this[`_original${functionName}`] = originalGetter.call(this);
        }
        return this[`_original${functionName}`];
    }
    get.isMemoized = true;
    Object.defineProperty(scope, functionName, {
        get,
    });
};
class ComplexDataError extends Error {
    constructor(message, complexInstance) {
        super(message);
        this.complexInstance = complexInstance;
        this.details = this.complexInstance.getData();
    }
}
exports.ComplexDataError = ComplexDataError;
class DisposableComplexDataError extends ComplexDataError {
    constructor(message, complexInstance) {
        super(message, complexInstance);
        this.complexInstance = complexInstance;
    }
}
exports.DisposableComplexDataError = DisposableComplexDataError;
const doNotFilter = () => true;
const ARRAY_PROTOTYPE_KEYS = Reflect.ownKeys(Object.getOwnPropertyDescriptors(Array.prototype));
const PROMISE_PROTOTYPE_KEYS = Reflect.ownKeys(Object.getOwnPropertyDescriptors(Promise.prototype));
const PROXY_NON_ENUMERABLE_KEYS = new Set([...ARRAY_PROTOTYPE_KEYS, ...PROMISE_PROTOTYPE_KEYS]);
class ComplexData extends connectedData_1.default {
    get conditionalKeys() {
        return this.constructor.conditionalKeys;
    }
    static get ERRORS() {
        return {};
    }
    static getComplexModel() {
        return this;
    }
    static get indexedSearchConfig() {
        return {};
    }
    static createJoinConfigFromAssociation(joinCondition) {
        const joinConfig = { type: 'child', fieldName: '' };
        [...Object.keys(joinCondition), ...Object.getOwnPropertySymbols(joinCondition)].forEach(propKey => {
            const joinKey = typeof propKey === 'string' ? propKey : propKey.description;
            const joinValue = joinCondition[propKey];
            if (typeof joinValue === 'symbol' && (joinKey === 'id' || joinValue.description === 'id')) {
                if (joinKey === 'id') {
                    joinConfig.type = 'parent';
                    joinConfig.fieldName = joinValue.description.replace('f_', '');
                }
                else {
                    joinConfig.fieldName = joinKey;
                }
            }
            else {
                let condition;
                if (joinKey !== '$or') {
                    const scope = typeof propKey === 'symbol' ? 'joined' : 'self';
                    condition = { scope, key: joinKey, value: joinValue };
                }
                else {
                    condition = joinValue.map((subConditionDef) => this.createJoinConfigFromAssociation(subConditionDef).conditions);
                }
                if (joinConfig.conditions) {
                    joinConfig.conditions.push(condition);
                }
                else {
                    joinConfig.conditions = [condition];
                }
            }
        });
        return joinConfig;
    }
    static getIndexedSearchMap(joinConfig = { type: 'root' }, followConfig = {}) {
        const castedThis = this;
        const ownSearchableFields = castedThis.Entity.fields.filter(definition => definition.fulltextSearchField);
        const connectedSearchMaps = [];
        const searchConfig = castedThis.indexedSearchConfig;
        const shallowSearch = joinConfig.type === 'root' && followConfig.searchOnly;
        if (!shallowSearch && Object.keys(searchConfig).length) {
            const { source, searchOnly } = followConfig;
            const configsToSearch = Object.entries(searchConfig).filter(([key]) => {
                if (searchOnly && !searchOnly.includes(key)) {
                    return false;
                }
                return castedThis.allowedAssociations[key].instance.name !== source;
            });
            configsToSearch.forEach(([searchAssociationKey, searchAssociationConfig]) => {
                const joinCondition = castedThis.allowedAssociations[searchAssociationKey].condition;
                const subJoinConfig = { joinName: searchAssociationKey, ...castedThis.createJoinConfigFromAssociation(joinCondition) };
                const subFollowConfig = { source: castedThis.name };
                if (typeof searchAssociationConfig !== 'boolean') {
                    subFollowConfig.searchOnly = Object.keys(searchAssociationConfig);
                }
                connectedSearchMaps.push(castedThis.allowedAssociations[searchAssociationKey].instance.getIndexedSearchMap(subJoinConfig, subFollowConfig));
            });
        }
        else if (ownSearchableFields.length === 0) {
            throw new Error(`Indexed text search is not defined on ${castedThis.name}}`);
        }
        let fieldsToSearch = ownSearchableFields;
        if (shallowSearch) {
            if (followConfig.searchOnly.some(searchField => ownSearchableFields.findIndex(fieldDef => fieldDef.name === searchField) < 0)) {
                throw new Error(`${castedThis.name} does not have the required searchable fields for shallow search!`);
            }
            fieldsToSearch = ownSearchableFields.filter(searchField => followConfig.searchOnly.includes(searchField.name));
        }
        return {
            modelName: castedThis.name,
            fieldsToSearch,
            joinConfig,
            connectedSearchMaps,
        };
    }
    static recordMatchesJoinConditions(record, recordPropGetter, conditions, scope) {
        if (!conditions) {
            return true;
        }
        let result = true;
        const conditionsInScope = conditions.filter(condition => Array.isArray(condition) || condition.scope === scope);
        conditionsInScope.forEach(condition => {
            if (Array.isArray(condition)) {
                let conditionArrayResult = false;
                condition.forEach(subCondition => {
                    conditionArrayResult = conditionArrayResult || this.recordMatchesJoinConditions(record, recordPropGetter, [subCondition], scope);
                });
                result = result && conditionArrayResult;
            }
            else {
                result = result && recordPropGetter(record, condition.key) === condition.value;
            }
        });
        return result;
    }
    static async *getConnectedSearchMatchRecords(searchTerm, searchMap, storeFunctionsGetter, matchOnly, isRootCall) {
        const { simpleQueryFunction, recordPropGetterFunction: modelPropGetter } = storeFunctionsGetter(searchMap.modelName);
        const recordPropGetterFunction = (record, propName) => {
            if (isRootCall) {
                return modelPropGetter(record, propName);
            }
            if (record.data) {
                return record.data[propName];
            }
            return record[propName];
        };
        const generators = searchMap.connectedSearchMaps.map(subSearchMap => ({ searchMap: subSearchMap, iterator: this.performIndexedSearch(searchTerm, subSearchMap, storeFunctionsGetter, false, matchOnly), results: [] }));
        const next = (generator) => {
            const promise = generator.iterator.next().then(({ done, value }) => ({
                done, generator: { ...generator, results: [...generator.results, ...value] }, promise,
            }));
            return promise;
        };
        const promises = generators.reduce((set, gen) => set.add(next(gen)), new Set());
        try {
            while (promises.size > 0) {
                const { done, generator, promise,
                // eslint-disable-next-line no-await-in-loop
                 } = await bluebird_1.default.race(promises);
                promises.delete(promise);
                const { joinConfig: subJoinConfig } = generator.searchMap;
                const { results: subSearchResults } = generator;
                const propToFilter = subJoinConfig.type === 'parent' ? subJoinConfig.fieldName : 'id';
                if (!subSearchResults.length) {
                    if (!done) {
                        promises.add(next(generator));
                    }
                }
                else {
                    /**
                     * @TODO performance
                     * IF we don't do the index optimization in indexeddb we can still try to merge `subSearchResult` and issue a single
                     * `simpleQueryFunction` which can match documents for every independent `subSearchResult`.
                     * This is now optimised, but if we have matches in multiple connected records, we run a full query on `document` table
                     * as many times as many different connected data we have.
                     */
                    const subSearchResultRecords = subSearchResults.map(result => result.record);
                    const subSearchRecordChunks = _.chunk(subSearchResultRecords, 200);
                    const connectedRecords = [];
                    // eslint-disable-next-line no-await-in-loop
                    await bluebird_1.default.map(subSearchRecordChunks, async (recordChunk) => {
                        const connectedChunk = await simpleQueryFunction(propToFilter, 'in', recordChunk, !isRootCall);
                        connectedRecords.push(...connectedChunk);
                    }, { concurrency: 20 });
                    const filteredRecords = connectedRecords.map((connectedRecord) => {
                        if (this.recordMatchesJoinConditions(connectedRecord, recordPropGetterFunction, subJoinConfig.conditions, 'joined')) {
                            const needle = recordPropGetterFunction(connectedRecord, propToFilter);
                            const { matchedFields } = subSearchResults.find((subResult) => needle === subResult.record) || {};
                            if (matchedFields) {
                                return { record: connectedRecord, matchedFields: matchedFields.map((fieldName) => (isRootCall ? fieldName : `${searchMap.modelName}.${fieldName}`)) };
                            }
                        }
                        return false;
                    }).filter(record => record !== false);
                    if (filteredRecords.length) {
                        yield filteredRecords;
                    }
                    if (!done) {
                        promises.add(next(generator));
                    }
                }
            }
            return { done: true, record: null, matchedFields: [] };
        }
        finally {
            await bluebird_1.default.each(generators, async (generator) => {
                await generator.iterator.return([]);
            });
        }
    }
    static async getFieldSearchMatchRecords(searchTerm, searchMap, storeFunctionsGetter, matchOnly) {
        const { modelName, joinConfig } = searchMap;
        const { indexedSearchFunction } = storeFunctionsGetter(modelName);
        const searchResults = [];
        if (searchMap.fieldsToSearch.length) {
            const resultKeyPrefix = joinConfig.type === 'root' ? '' : `${joinConfig.joinName || searchMap.modelName}.`;
            const matches = await indexedSearchFunction(searchTerm, searchMap.fieldsToSearch, matchOnly);
            matches.forEach(record => {
                searchResults.push({ record, matchedFields: record.data.searchData.matchedFields.map((fieldName) => `${resultKeyPrefix}${fieldName}`) });
            });
        }
        return searchResults;
    }
    static processSearchResultRecord(matchedRecord, joinConfig, recordPropGetter) {
        const { record, matchedFields } = matchedRecord;
        const propToMap = joinConfig.type === 'child' ? joinConfig.fieldName : 'id';
        if (this.recordMatchesJoinConditions(record, recordPropGetter, joinConfig.conditions, 'self')) {
            return { record: recordPropGetter(record, propToMap), matchedFields };
        }
        return false;
    }
    static async *performIndexedSearch(searchTerm, searchMap, storeFunctionsGetter, isRootCall, matchOnly) {
        const { joinConfig, modelName } = searchMap;
        const { recordPropGetterFunction } = storeFunctionsGetter(modelName);
        const fieldSearchMatches = await this.getFieldSearchMatchRecords(searchTerm, searchMap, storeFunctionsGetter, matchOnly);
        const connectedSearchIterator = this.getConnectedSearchMatchRecords(searchTerm, searchMap, storeFunctionsGetter, matchOnly, isRootCall);
        try {
            const { value: connectedSearchRecords, done: connectedSearchDone } = await connectedSearchIterator.next();
            let matchRecords = fieldSearchMatches.length > 0 ? fieldSearchMatches : connectedSearchRecords;
            let fieldSearchDone = fieldSearchMatches.length === 0;
            let searchFinished = fieldSearchDone && connectedSearchDone;
            while (!searchFinished) {
                let resultRecords = matchRecords;
                if (isRootCall) {
                    const propsToMap = ['id', ...(joinConfig.externalFilterProps || [])];
                    const returnFullRecord = joinConfig.externalFilterProps === 'fullRecord';
                    if (!returnFullRecord) {
                        resultRecords = matchRecords.map((matchRecord) => {
                            const mappedRecord = {};
                            propsToMap.forEach(propName => {
                                mappedRecord[propName] = recordPropGetterFunction(matchRecord.record, propName);
                            });
                            matchRecord.record = mappedRecord;
                            return matchRecord;
                        });
                    }
                    yield resultRecords;
                }
                else {
                    const filteredRecords = matchRecords.map((matchRecord) => this.processSearchResultRecord(matchRecord, joinConfig, (record, propName) => (record.data ? record.data[propName] : record[propName]))).filter((record) => record !== false);
                    if (filteredRecords.length) {
                        yield filteredRecords;
                    }
                }
                if (!fieldSearchDone) {
                    fieldSearchDone = true;
                }
                if (fieldSearchDone) {
                    // eslint-disable-next-line no-await-in-loop
                    const { done, value } = await connectedSearchIterator.next();
                    searchFinished = done;
                    matchRecords = value;
                }
            }
            return [];
        }
        finally {
            if (connectedSearchIterator) {
                await connectedSearchIterator.return([]);
            }
        }
    }
    static searchByIndex(searchTerm, complexObject, externalFilterProps, searchOnly, matchOnly) {
        const castedThis = this;
        const searchMap = castedThis.getIndexedSearchMap({ type: 'root', externalFilterProps }, { searchOnly });
        return complexObject.searchStringByIndex(searchTerm, searchMap, castedThis.performIndexedSearch.bind(castedThis), matchOnly);
    }
    static async callExternalFunction(complexObject, functionName, args) {
        return complexObject.callExternalFunction(functionName, args);
    }
    static async getAll(complexObject) {
        const castedThis = this;
        const response = await complexObject.loadGenericData(castedThis);
        const responseData = response?.responseData || [];
        return bluebird_1.default.map(responseData, data => castedThis.build(data, {}, {
            listeners: complexObject.getRootListenerMap(baseData_1.default.EXTERNAL_EVENTS),
            cache: complexObject.cache,
        }));
    }
    static async build(data, extraData = {}, { listeners = {}, parent = null, cache = null, disposable = false, } = {
        parent: null,
        listeners: {},
        cache: null,
        disposable: false,
    }) {
        const castedThis = this;
        if (!cache) {
            return castedThis.buildInstance(data, extraData, {
                parent, listeners, cache, disposable,
            });
        }
        const storeName = castedThis.modelDefinition.modelName;
        const { id } = data;
        const cached = cache.get(storeName, id);
        if (cached) {
            return cached;
        }
        const keyId = id !== null && typeof id === 'symbol' ? id.toString() : id;
        const runningPromiseKey = `${storeName}-${keyId}`;
        let runningPromise = castedThis.runningBuildPromises.get(runningPromiseKey);
        if (!runningPromise) {
            runningPromise = castedThis.buildInstance(data, extraData, {
                parent, listeners, cache, disposable,
            });
            if (id !== null) {
                castedThis.runningBuildPromises.set(runningPromiseKey, runningPromise);
            }
        }
        return runningPromise
            //  .finally polyfill
            .then(result => {
            castedThis.runningBuildPromises.delete(runningPromiseKey);
            return result;
        })
            .catch(error => {
            castedThis.runningBuildPromises.delete(runningPromiseKey);
            throw error;
        });
    }
    static async buildInstance(data, extraData = {}, { listeners = {}, parent = null, cache = null, disposable = false, } = {
        parent: null,
        listeners: {},
        cache: null,
        disposable: false,
    }) {
        const instance = new this(data, extraData, {
            parent, listeners, cache, fromBuilder: true, disposable,
        });
        instance.deletedItemsHolderForClone = [];
        await instance.fillAssociatedValues(extraData, true, true);
        await instance.init();
        await Promise.all(instance.deletedItemsHolderForClone.map(deletedItem => deletedItem.delete()));
        return instance;
    }
    async init() {
        //
        // This would be better placed in class BaseData. But in that case initNewItem
        // in the inherited classes couldn't access associations. So it is moved here.
        //
        if (this.isNewItem() && !this.shouldSkipDefaults()) {
            await this.initNewItem();
        }
    }
    shouldSkipDefaults() {
        return Boolean(this.extraData[skipDefaultsSymbol]);
    }
    /**
     * Default constructor to create a new instance. As it is a singleton we
     * should make sure there is only one instance exists.
     *
     * @param {DataObject} data
     * @param {DataObject} extraData
     * @param {boolean} fromBuilder
     * @param {{string?: Function}} listeners
     * @param {ComplexData} parent
     * @param {Cache} cache
     */
    // public constructor(data: DataObject, listeners: { string?: Function | Function[] } = {}, cache = new Cache());
    constructor(data, extraData = {}, { fromBuilder = false, listeners = {}, parent = null, cache = null, disposable = false, } = {
        parent: null,
        fromBuilder: false,
        listeners: {},
        cache: null,
        disposable: false,
    }) {
        super(data, {}, { listeners, cache, disposable });
        this.associatedValues = {};
        this.associatedValueLoadingOptions = {};
        this.deletedAssociatedItems = [];
        this.loadedAssociationValuesKeys = {};
        this.joinTables = {};
        this.proxyMap = {};
        this.deletedItemsHolderForClone = [];
        this.initialId = null;
        this.saving = null;
        this.initialized = false;
        /**
         * Remove ourselves from all associations of the passed in instance
         *
         * @param {ComplexData} associatedItem
         */
        this.reverseAssociationCleanupRunning = false;
        /**
         * If you ever wonder why, then static initialization is kinda messed up with classes.
         * So we check this flag on the _current_ class, if there isn't one yet, lets set it.
         * There is a test for the issue caused if you remove this.
         */
        if (!Object.prototype.hasOwnProperty.call(this.constructor, 'associationsProcessed')) {
            this.constructor.associationsProcessed = false;
        }
        if (data[isUpdatedSymbol]) {
            this.data.setDirty();
        }
        if (data[isDeletedSymbol]) {
            this.privateDeleted = true;
        }
        this.extraData = extraData;
        if (!fromBuilder) {
            const isNewInstance = this.isNewItem();
            if (!disposable) {
                this.initAssociatedValues(isNewInstance);
            }
        }
        if (!this.constructor[decorator_1.skipAddToCacheOnConstruct]) {
            if (!this.disposable) {
                this.addEventHandlers();
            }
            if (parent) {
                parent.setupEventForwarding(this);
            }
            this.addToCache(this);
        }
        this._parent = parent;
        this.initialized = true;
    }
    /**
     * initialisation method for MixedClasses (using @complexDataMix decorator for applying mixins on a class)
     * currently the ts-mixer call every class's constructor on mixing classes, so it would add the original instance into the cache, not the MixedClass instance.
     * But we want the MixedClass instance in the cache with all the mixins applied on.
     *
     * So when the ts-mixer finished with all the classed mixing it will call this and we add the mixed instance to the cache here
     */
    complexDataMixConstructor(data) {
        if (!this.disposable) {
            this.addEventHandlers();
        }
        if (this._parent) {
            this._parent.setupEventForwarding(this);
            this._parent = undefined;
        }
        this.setMonitoredEntity(data);
        this.setId();
        this.processAssociations();
        this.addToCache(this);
    }
    static buildConditionalKeys() {
        if (!Object.hasOwnProperty.call(this, 'conditionalKeys')) {
            this.conditionalKeys = new Set();
        }
        Object.values(this.allowedAssociations).forEach(({ condition = {} }) => {
            Object.values(condition).forEach(conditionValue => {
                if (typeof conditionValue === 'symbol') {
                    this.conditionalKeys.add(this.Entity.fieldSymbolValues[conditionValue]);
                }
            });
        });
    }
    initAssociatedValues(isNewInstance) {
        this.fillAssociatedValues(this.extraData, true, false);
        if (isNewInstance) {
            this.init();
        }
    }
    postCreate() {
        /**
         * Please read the comment for `complexDataMixConstructor` if unsure why we _need_ this.
         */
        if (!this.constructor[decorator_1.skipAddToCacheOnConstruct]) {
            this.processAssociations();
        }
    }
    get reverseAssociations() {
        if (this.cache) {
            return this.cache.reverseAssociations.get(this.constructor.getModelName(), this.data.id);
        }
        return new Set();
    }
    /**
     * Override this method in inherited classes
     * in order to add additional initialisation to newly created items
     * (e.g. add regular contact methods to a new contact)
     */
    async initNewItem() {
        if (this.disposable) {
            return;
        }
        this.initDefaultValues();
        await this.initDefaultAssociatedItems();
    }
    // eslint-disable-next-line class-methods-use-this, no-empty-function
    async initDefaultAssociatedItems() {
    }
    getGeneratedAssociatedValueItems(associationName) {
        const items = this.getGeneratedAssociatedValueItemsObject(associationName);
        const foundItems = (0, object_1.getValuesIncludingSymbolProperties)(items, [valuesAsArrayKey]);
        const filteredItems = foundItems
            .filter(Boolean)
            .filter(item => (!item[instanceSymbol] || !item[instanceSymbol].isDeleted));
        //
        // replace items in array
        //
        items[valuesAsArrayKey].splice(0, items[valuesAsArrayKey].length, ...filteredItems);
        return items[valuesAsArrayKey];
    }
    initDefaultValues() {
        this.data.suppressEvents();
        this.constructor.Entity.fields.forEach((field) => {
            if (typeof field.defaultValue !== 'undefined' && typeof this.data[field.name] === 'undefined') {
                let { defaultValue } = field;
                if (typeof field.defaultValue === 'function') {
                    defaultValue = field.defaultValue();
                }
                // @ts-ignore
                this.data[field.name] = defaultValue;
            }
        });
        //
        // Data maybe will change in the event handler, so lets do this while the events are suppressed.
        //
        this.emit(ComplexData.EVENTS.MODEL_DATA_INITIALISED, this);
        this.data.unSuppressEvents();
    }
    fillAssociatedValues(extraData, isSync = false, fromBuilder = false, filter = () => true) {
        const actualAssociations = Object.entries(this.constructor.allowedAssociations)
            .filter(filter);
        let isPromise = false;
        const associatedValues = actualAssociations.map(([key, associationDefinition]) => {
            const { ItemConstructor, lookupKey, conditions, } = ComplexData.getAssociationConfig(key, associationDefinition);
            const items = this.getAssociatedValuesByKey({ lookupKey, isSync, extraData });
            if (items.then) {
                isPromise = true;
            }
            return this.processForeignRecords({
                items, ItemConstructor, key, associationDefinition,
            }, fromBuilder);
        });
        if (isPromise) {
            return bluebird_1.default.each(associatedValues, async (associatedValue) => associatedValue);
        }
        return associatedValues;
    }
    processForeignRecords({ items, ItemConstructor, key, associationDefinition, }, fromBuilder = false) {
        const filteredRecords = items
            .filter(item => this.itemMatchesAllConditions(item, associationDefinition));
        const isPromise = !!filteredRecords.then; // filteredRecords.some(record => record.then);
        if (isPromise) {
            return bluebird_1.default.each(filteredRecords, async (item) => {
                const foreignRecordItem = await item;
                this.addNewAssociatedItem({
                    ItemConstructor,
                    item: foreignRecordItem,
                    isSingle: Boolean(associationDefinition.single),
                    associationName: key,
                }, fromBuilder);
            });
        }
        return filteredRecords.forEach(item => {
            this.addNewAssociatedItem({
                ItemConstructor,
                item,
                isSingle: Boolean(associationDefinition.single),
                associationName: key,
            }, fromBuilder);
        });
    }
    getAssociatedValuesByKey({ lookupKey, isSync, extraData }) {
        let items;
        if (isSync) {
            items = extraData[lookupKey] || [];
        }
        else {
            items = extraData[lookupKey] || this.getAssociatedValue(lookupKey).map(item => item.data.getDataValues()) || [];
        }
        return items;
    }
    hasFullDatasetLoaded(associationName) {
        return [JSON.stringify({}), JSON.stringify({ filters: [] })].some(key => this.associatedValueLoadingOptions[associationName]?.[key]);
    }
    hasAssociationLoaded(associationName, options) {
        const optionsKey = ComplexData.generateLoadOptionKey(options);
        if (this.hasFullDatasetLoaded(associationName)) {
            return true;
        }
        if (this.alwaysRequestRemoteData() && (options.limit || options.skip || options.sorters)) {
            return false;
        }
        return Boolean(this.associatedValueLoadingOptions[associationName]?.[optionsKey]);
    }
    markAssociationLoaded(associationName, options) {
        const optionsKey = ComplexData.generateLoadOptionKey(options);
        this.associatedValueLoadingOptions[associationName] = {
            ...(this.associatedValueLoadingOptions[associationName] || {}),
            [optionsKey]: true,
        };
    }
    alwaysRequestRemoteData() {
        const configDefined = typeof process.env.ALWAYS_REQUEST_REMOTE_DATA !== 'undefined';
        return configDefined && process.env.ALWAYS_REQUEST_REMOTE_DATA;
    }
    static generateLoadOptionKey(options) {
        return JSON.stringify(options, (key, value) => (typeof value === 'symbol' ? JSON.stringify(String(value)) : value));
    }
    static isOptionsEmpty(options) {
        return !(options.limit || options.skip || options.sorters || options.filters);
    }
    isAssociationSingle(associationName) {
        return Boolean(this.constructor.allowedAssociations[associationName].single);
    }
    getAssociatedValue(associationName, options = {}) {
        if (!this.canGetFromAssociatedValues(associationName, options)) {
            //
            // If the condition has any symbol value then it is a new item that is not yet saved.
            // Therefore, it is meaningless to try loading
            //
            if (!this.disposable && this.isAnyConditionWithSymbolValue(associationName)) {
                return this.getAssociatedValuesFromCache(associationName);
            }
            //
            // If the association is single and we have that item loaded already into associatedValues
            // or in the cache, then we can just return that item.
            //
            if (this.isAssociationSingle(associationName)) {
                const itemInCache = this.getAssociatedValuesFromCache(associationName);
                if (itemInCache.length > 0) {
                    return itemInCache;
                }
            }
            return this.loadAssociatedValues(associationName, options);
        }
        return ComplexData.applyOptions(this.associatedValues[associationName] || [], options);
    }
    ensureItemsHaveListeners(items) {
        items.forEach(item => this.setupEventForwarding(item));
    }
    static applyOptions(values, options = {}) {
        let filterFn = doNotFilter;
        if (values.length > 0 && options.filters) {
            filterFn = FilterBuilder.createFilterFn(options.filters);
        }
        const filtered = values.filter(item => filterFn(item.data));
        if (filtered.length > 0 && options.sorters) {
            const sorterFn = FilterBuilder.createSorterFn(options.sorters);
            filtered.sort((itemA, itemB) => sorterFn(itemA.data, itemB.data));
        }
        if (filtered.length > options.limit) {
            const start = options.skip || 0;
            const end = options.limit ? start + options.limit : filtered.length;
            return filtered.slice(start, end);
        }
        return filtered;
    }
    /**
     * Check if any used values in the condition is a Symbol
     *
     * @param {string} associationName
     * @returns {boolean}
     */
    isAnyConditionWithSymbolValue(associationName) {
        return Object.values(this.generateConditions(associationName)).some(value => typeof value === 'symbol');
    }
    isItemInExtraData(item) {
        if (_.isEmpty(this.extraData)) {
            return false;
        }
        return Object.values(this.extraData).some(extraDataItem => Object.values(extraDataItem).includes(item));
    }
    async getAssociatedValueCount(associationName, filters) {
        const options = { limit: 1, skip: 0, filters };
        if (this.isListenerBound(baseData_1.default.EVENTS.MODEL_DATA_REQUEST) && !this.canGetFromAssociatedValues(associationName, options)) {
            if (this.isAnyConditionWithSymbolValue(associationName)) {
                return 0;
            }
            const associatedValuesKey = this.constructor.allowedAssociations[associationName].key;
            options.filters = this.extendFiltersWithConditions(associationName, options.filters);
            const associatedValues = await this.filterAssociatedData(associatedValuesKey, options);
            if (associatedValues?.responseData?.total) {
                return associatedValues?.responseData?.total;
            }
            return associatedValues && associatedValues.responseData ? associatedValues.responseData.length : 0;
        }
        return this.associatedValues[associationName]?.length || 0;
    }
    getAssociatedValuesFromCache(associationName) {
        //
        // With staged loading we may already have it loaded actually
        //
        if (typeof this.associatedValues[associationName] !== 'undefined') {
            return this.associatedValues[associationName];
        }
        if (!this.cache) { // TODO PN-7728
            return [];
        }
        const associatedItemName = this.constructor.allowedAssociations[associationName].instance.getModelName();
        const condition = this.generateConditions(associationName);
        if (Object.prototype.hasOwnProperty.call(condition, 'id')) {
            const item = this.cache.get(associatedItemName, condition.id);
            if (item && this.itemMatchesAllConditions(item.data.getDataValues(), { ...this.constructor.allowedAssociations[associationName], condition })) {
                //
                // Items received from cache may not have listeners connected to this item so
                // make sure they have connection. The same applies to the other return pah below
                //
                this.ensureItemsHaveListeners([item]);
                return [item];
            }
            return [];
        }
        const cachedItems = this.cache.getCachedItemsByFilter(associatedItemName, (item => item && this.itemMatchesAllConditions(item.data.dataValues, { ...this.constructor.allowedAssociations[associationName], condition })));
        this.ensureItemsHaveListeners(cachedItems);
        return cachedItems;
    }
    getValueOfConditionWithSymbolId(associationName) {
        const condition = Object.entries(this.generateConditions(associationName)).find(([key, value]) => (key === 'id' && typeof value === 'symbol'));
        return condition ? condition[1] : null;
    }
    generateConditions(associationName, ignoredAssociationConditionKeys = []) {
        const original = this.constructor.allowedAssociations[associationName].condition || {};
        return Object.entries(original)
            .filter(([associationKey]) => !ignoredAssociationConditionKeys.includes(associationKey))
            .reduce((copy, [key, value]) => {
            copy[key] = (typeof value === 'symbol') ? this.data[this.constructor.Entity.fieldSymbolValues[value]] : value;
            return copy;
        }, {});
    }
    /**
     * Determines if the association is already loaded and we can use the internal associatedValues array rather than
     * looking out to datawrapper.
     *
     * NOTE: currently lookup in associatedValues does not work because partially loaded datasets can not deal with
     * skip and limit options. E.g. loading associations in an empty associatedValues array by using a {skip: x} option
     * will not add the loaded values starting at index x to the associatedValues array, but it will add to the beginning.
     * Therefore subsequent calls with the same options will not be able to apply the skip/limit option properly.
     *
     * @param associationName
     * @param options
     * @private
     */
    canGetFromAssociatedValues(associationName, options) {
        const associatedValuesKey = this.constructor.allowedAssociations[associationName].key;
        return !this.disposable && this.hasAssociationLoaded(associatedValuesKey, options) && !options.skip && !options.limit;
    }
    /**
     * Load associated values via messages sent to the wrapper
     *
     * @param {string} associationName
     * @param {object} options - optional paging and filtering options
     * @returns {Promise<*>}
     */
    loadAssociatedValues(associationName, options = {}) {
        const associatedValuesKey = this.constructor.allowedAssociations[associationName].key;
        const filters = this.extendFiltersWithConditions(associationName, options.filters);
        const updatedOptions = { ...options, filters };
        if (this.isListenerBound(baseData_1.default.EVENTS.MODEL_DATA_REQUEST) && !this.canGetFromAssociatedValues(associationName, updatedOptions)) {
            return this.loadAssociatedData(associatedValuesKey, {
                ...updatedOptions,
                filters,
            })
                .then(async ({ responseData = [] } = {}) => {
                if (!this.disposable) {
                    /**
                     * I have a feeling that we should not run into this on subsequent responses, as assications and items
                     * already created. This is now working, but if we have all the responseData in associatedValues items we should
                     * skip this.
                     */
                    await this.fillAssociatedValues({ [associatedValuesKey]: responseData }, false, false, ([_key, association]) => (association.key === associatedValuesKey));
                    this.markAssociationLoaded(associatedValuesKey, updatedOptions);
                }
                /**
                 * What we want here is to change the plain responsData array to an array with complexData instances while managing the ordering of items.
                 */
                const responseDataToProcess = responseData || [];
                const modelClassName = this.constructor.allowedAssociations[associationName].instance.getModelName();
                /** This is just disgusting, we have to force to generate complexInstances to be able to make fast lookups from cache
                 * Or we could iterate through associatedValues for every responseData element. This is just something which
                 * should be improved, but can't use associatedValueItems, as it is a map for sure, but not instances, only
                 * dataValues, and won't create complexData instances on access.
                 */
                const associatedValues = this.associatedValues[associationName] || [];
                if (this.cache && !this.disposable) {
                    associatedValues.forEach(dummy => dummy);
                    return responseDataToProcess.map(responseItem => this.cache.get(modelClassName, responseItem.id)).filter(Boolean);
                }
                if (this.disposable) {
                    return responseDataToProcess;
                }
                return responseData.map(responseItem => associatedValues.find(associatedValue => associatedValue.dataValues.id === responseItem.id)).filter(Boolean);
            });
        }
        return ComplexData.applyOptions(this.associatedValues[associationName] || [], updatedOptions);
    }
    extendFiltersWithConditions(associationName, filters = []) {
        const conditions = this.generateConditions(associationName);
        const conditionFilters = this.conditionToFilter(conditions);
        return [...filters, ...conditionFilters];
    }
    async getAssociatedValueById(associationName, id, options = {}) {
        const associatedValues = await this.getAssociatedValue(associationName, options);
        return associatedValues.find(item => item.data.id === id);
    }
    /**
     * Check if foreign key relations are used
     *
     * @param items
     * @param foreignOptions
     * @returns {*}
     * @private
     */
    getForeignRecords(items, foreignOptions) {
        //
        // Don't have foreign key definition? Just return the items as is
        //
        if (Object.keys(foreignOptions).length === 0 && foreignOptions.constructor === Object) {
            return items;
        }
        let isPromise = false;
        //
        // Got foreign key definitions... process them and convert the items to associated items
        //
        const foreignRecords = items.reduce((currentForeignRecords, item) => {
            const associatedItem = this.getItemByAssociation(item, foreignOptions);
            const returnValue = associatedItem ? [...currentForeignRecords, associatedItem] : currentForeignRecords;
            if (returnValue.then) {
                isPromise = true;
            }
            return returnValue;
        }, []);
        if (isPromise) {
            return bluebird_1.default.map(foreignRecords, async (foreignRecord) => foreignRecord);
        }
        return foreignRecords;
    }
    /**
     * Get an item by association. Using the passed in foreign key definition this
     * function checks whether the passed in item matches the required conditions
     *
     * @param {DataObject} associationItem
     * @param {ForeignKeyDefinition} foreignOptions
     * @returns {null}
     */
    getItemByAssociation(associationItem, foreignOptions) {
        const conditions = foreignOptions.condition || {};
        const meetsCondition = Object.entries(conditions)
            .every(([filterKey, value]) => ((typeof value === 'symbol' && associationItem[filterKey] === this.data[this.constructor.Entity.fieldSymbolValues[value]])
            || (typeof value !== 'symbol' && associationItem[filterKey] === value)));
        if (meetsCondition) {
            const associatedValue = this.getAssociatedValue(foreignOptions.associatedModel);
            if (typeof associatedValue?.then === 'function') {
                return associatedValue?.then(loadedAssociatedValue => this.findAssociatedItems(loadedAssociatedValue, foreignOptions, associationItem));
            }
            return this.findAssociatedItems(associatedValue, foreignOptions, associationItem);
        }
        return null;
    }
    findAssociatedItems(associatedValue, foreignOptions, associationItem) {
        return associatedValue.map(item => item.data.getDataValues())
            .find(item => Object.entries(foreignOptions.associatedField)
            .every(([key, value]) => item[value] === associationItem[key]));
    }
    itemMatchesAllConditions(item, associationDef) {
        const conditions = associationDef?.condition;
        const ownKeys = conditions && Reflect.ownKeys(conditions);
        if (!ownKeys) {
            return true;
        }
        return ownKeys.map(key => [key, conditions[key]]).every(([filterKey, value]) => {
            if (filterKey === '$or' && Array.isArray(value)) {
                return value.some(orCondition => this.itemMatchesAllConditions(item, { ...associationDef, condition: orCondition }));
            }
            if (filterKey === 'company_id' && typeof item[filterKey] === 'undefined') {
                return true;
            }
            if (typeof value === 'symbol') {
                //
                // It can be symbol either because it is a field symbol or because it is a new item with symbol id
                // So first check if it is a field symbol
                //
                if (this.constructor.Entity.fieldSymbolValues[value]) {
                    //
                    // If field symbol then check if the value of the field is the same as the field
                    // referenced by the symbol
                    //
                    return item[filterKey] === this.data[this.constructor.Entity.fieldSymbolValues[value]];
                }
                //
                // Otherwise it is a new item with symbol id, so just check the value
                //
                return item[filterKey] === value;
            }
            if (typeof filterKey === 'symbol') {
                if (typeof this.constructor.Entity.fieldSymbolValues[filterKey] === 'undefined') {
                    throw Object.assign(new Error('Condition symbol key cannot be found in entity\'s fieldSymbolValus'), {
                        details: {
                            conditions,
                            filterKey,
                            item,
                        },
                    });
                }
                return this.data[this.constructor.Entity.fieldSymbolValues[filterKey]] === value;
            }
            return (item[filterKey] === value);
        });
    }
    static getAssociationConfig(key, associationDefinition) {
        const lookupKey = associationDefinition.key;
        return {
            lookupKey,
            ItemConstructor: associationDefinition.instance,
            conditions: associationDefinition.condition || {},
            isSingle: associationDefinition.single !== undefined ? associationDefinition.single : false,
            methodName: this.getMethodName(key),
        };
    }
    static getMethodName(key) {
        return key.charAt(0).toUpperCase() + key.slice(1);
    }
    /**
     * Process available associations and construct add/remove, etc
     * methods for them
     *
     * @private
     */
    processAssociations() {
        if (!Object.getOwnPropertyDescriptor(this.constructor, 'associationsProcessed')?.value) {
            if (!this.constructor.conditionalKeys || this.constructor.conditionalKeys.size === 0) {
                this.constructor.buildConditionalKeys();
            }
            memoizeGetter(this.constructor, 'allowedAssociations');
            memoizeGetter(this.constructor, 'allowedAssociationsByConstructor');
            memoizeGetter(this.constructor, 'modelDefinition');
            memoizeGetter(this.constructor, 'serverOnlyFieldNames');
            Object.entries(this.constructor.allowedAssociations)
                .forEach(([key, associationDefinition]) => {
                this.constructor.getAssociationMethodDefinitions()
                    .forEach(methodDefinition => {
                    this.createMethod(key, associationDefinition, methodDefinition);
                });
            });
        }
        this.constructor.associationsProcessed = true;
    }
    /**
     * Create get/set/add/etc methods based on the association config
     *
     * @param {string} associationName
     * @param {AssociationDefinition} associationDefinition
     * @param {MethodDefinition} methodDefinition
     */
    createMethod(associationName, associationDefinition, methodDefinition) {
        const { methodName, ItemConstructor, isSingle, } = this.constructor.getAssociationConfig(associationName, associationDefinition);
        //
        // All methods except multiple in case of single :-)
        //
        if ((methodDefinition.isSingle === isSingle)) {
            const actualMethodName = methodDefinition.prefix + methodName + (methodDefinition.postfix || '');
            if (typeof this.constructor.prototype[actualMethodName] !== 'undefined') {
                throw new Error(`Method already exists: ${this.constructor.getModelName()}, ${actualMethodName}`);
            }
            //
            // If the association's ComplexData instance is defined as ComplexData class
            // then we do not want to instantiate these so the related methods should not
            // be created unless the method definition tells we do not need instance
            //
            if (!ItemConstructor && !methodDefinition.noInstanceNeeded) {
                return;
            }
            this.constructor.prototype[actualMethodName] = function (...args) {
                const result = methodDefinition.handler.apply(this, [{
                        ItemConstructor,
                        isSingle,
                        associationName,
                    }, ...args]);
                let pendingResult = result;
                if (['add', 'set', 'remove', 'unset'].includes(methodDefinition.prefix)) {
                    if (result.then) {
                        // eslint-disable-next-line no-async-promise-executor
                        pendingResult = new Promise(async (resolve) => {
                            await result;
                            this.noticeAssociationChange(associationName);
                            this.emit(ComplexData.EVENTS.OWN_ASSOCIATION_ADDED, { associationName, item: this });
                            resolve(result);
                        });
                    }
                    else {
                        this.noticeAssociationChange(associationName);
                        this.emit(ComplexData.EVENTS.OWN_ASSOCIATION_ADDED, { associationName, item: this });
                    }
                }
                return pendingResult;
            };
        }
    }
    noticeAssociationChange(associationName) {
        this.emit(ComplexData.EVENTS.ASSOCIATION_CHANGED, {
            association: this.constructor.allowedAssociations[associationName],
            item: this,
        });
    }
    /**
     * Abstract function to return associations available.
     * To be overridden by inherited classes
     *
     * @returns {{}}
     */
    static get allowedAssociations() {
        return {};
    }
    /**
     * This is a helper for filtering `allowedAssociations` more efficiently. We often run into code where we need
     * all associations for a given Model constructor. But to filter allowedAssociations, we have to convert it to an array
     * with Object.entries, then filter it and return that array. And we do that for every item where we fire an event.
     *
     * This function will create a Map, where the keys are the `instance` values in `associationConfig` and the value the value
     * of `associationConfig`'s keys where the `instance` is the the key's value.
     *
     * Then we convert it with Object.entries to be able to iterate on those associations immediately. This function is memoized, so
     * lazily evaulated once per model.
     *
     */
    static get allowedAssociationsByConstructor() {
        const { allowedAssociations } = this;
        const entries = Object.entries(allowedAssociations).reduce((associationMap, [key, value]) => {
            if (!associationMap.has(value.instance)) {
                associationMap.set(value.instance, {});
            }
            const associationsByInstance = associationMap.get(value.instance);
            associationsByInstance[key] = value;
            return associationMap;
        }, new Map());
        entries.forEach((value, key, map) => map.set(key, Object.entries(value)));
        return {
            get(itemConstructor) {
                return entries.get(itemConstructor) || [];
            },
        };
    }
    get fieldChangeEventHandlers() {
        return {};
    }
    getInitialId() {
        return this.initialId;
    }
    createProxy(associationName, extraData = {}) {
        const proxyTarget = this.getGeneratedAssociatedValueItems(associationName);
        return new Proxy(proxyTarget, {
            get: (target, key) => {
                if (PROXY_NON_ENUMERABLE_KEYS.has(key)) {
                    return target[key];
                }
                const currentItem = proxyTarget[key];
                if (!currentItem) {
                    return target[key];
                }
                return this.cacheItemInstance(currentItem, () => this.generateExtraDataForNewItem(extraData));
            },
            set: (target, key, value, ...args) => {
                let newValue = value;
                if (value && (0, ts_mixer_1.hasMixin)(value, ComplexData)) {
                    newValue = this.proxyMap[value.proxyMapKey];
                }
                return Reflect.set(target, key, newValue, ...args);
            },
        });
    }
    generateExtraDataForNewItem(extraData) {
        return Object.keys(extraData).length > 0 ? extraData : {
            ...Object.entries(this.associatedValueItems).reduce((currentExtraData, [key, value]) => {
                currentExtraData[key] = value[valuesAsArrayKey];
                return currentExtraData;
            }, {}),
        };
    }
    cacheItemInstance(currentItem, extraDataGenerator) {
        if (!currentItem[instanceSymbol]) {
            currentItem[instanceSymbol] = this.createItemInstance(currentItem, extraDataGenerator());
            currentItem[itemIsInstantiatedSymbol] = true;
        }
        return currentItem[instanceSymbol];
    }
    createItemInstance(item, extraData) {
        const { modelName } = item[constructorSymbol].prototype.constructor.modelDefinition;
        let instance = this.getInstanceFromCache(item, modelName);
        if (!instance) {
            instance = new item[constructorSymbol](item, extraData, {
                fromBuilder: true,
                parent: this,
                cache: this.cache,
            });
            instance.proxyMapKey = Symbol('proxyMapKey');
            this.proxyMap[instance.proxyMapKey] = item;
            const isNewInstance = instance.isNewItem() && !item[isNewSymbol];
            instance.initAssociatedValues(isNewInstance);
        }
        else {
            if (!instance.proxyMapKey) {
                instance.proxyMapKey = Symbol('proxyMapKey');
                this.proxyMap[instance.proxyMapKey] = item;
            }
            // @ts-ignore
            this.setupEventForwarding(instance);
        }
        return instance;
    }
    idUpdatedEvent({ item }) {
        let gotAssociation = false;
        this.constructor.allowedAssociationsByConstructor.get(item.constructor)
            .forEach(([associationName]) => {
            if (this.associatedValueItems[associationName]) {
                this.updateIdKeyInAssociatedValueItems(item.initialId, associationName, item.getIdWithState());
                gotAssociation = true;
            }
        });
        if (gotAssociation && typeof item.initialId === 'symbol') {
            this.emit(ComplexData.EVENTS.OWN_ASSOCIATION_ID_UPDATED, { item });
        }
    }
    itemSaved({ item }) {
        let gotAssociation = false;
        this.constructor.allowedAssociationsByConstructor.get(item.constructor)
            .forEach(([associationName]) => {
            if (this.associatedValueItems[associationName]) {
                gotAssociation = true;
            }
        });
        if (gotAssociation) {
            this.emit(ComplexData.EVENTS.OWN_ASSOCIATION_SAVED, { item });
        }
    }
    itemDeletedEvent({ item }) {
        if (item === this) {
            return;
        }
        this.reverseAssociationCleanupRunning = true;
        this.constructor.allowedAssociationsByConstructor.get(item.constructor)
            .forEach(([associationName, association]) => {
            this.removeAssociationLinks(association, item);
            const deleteIndex = this.associatedValues[associationName] && this.associatedValues[associationName].indexOf(item);
            if (this.deletedAssociatedItems.indexOf(item) < 0 && !item.isNewItem() && this.getAssociatedItemSet(true).has(item)) {
                this.deletedAssociatedItems.push(item);
            }
            if (deleteIndex >= 0) {
                this.associatedValues[associationName].splice(deleteIndex, 1);
                this.getGeneratedAssociatedValueItems(associationName);
                this.noticeAssociationChange(associationName);
            }
        });
        this.reverseAssociationCleanupRunning = false;
    }
    newItemAssociatedEvent({ itemCopy, associationKey, extraData }) {
        Object.entries(this.constructor.allowedAssociations)
            .filter(([_key, association]) => (association.key === associationKey))
            .forEach(([associationName, association]) => {
            if (association.instance === this.constructor && itemCopy.id === this.data.id) {
                return;
            }
            if (this.itemMatchesAllConditions(itemCopy, association)) {
                this.saveItemAndUpdateProxy(associationName, association, itemCopy, extraData);
            }
        });
    }
    addEventHandlers() {
        this.on(ComplexData.EVENTS.ID_UPDATED, this.idUpdatedEvent);
        this.on(ComplexData.EVENTS.SAVED, this.itemSaved);
        //
        // In case of Delete event lets check if this item is in any associations
        //
        this.on(ComplexData.EVENTS.ITEM_DELETED, this.itemDeletedEvent);
        this.on(ComplexData.EVENTS.NEW_ITEM_ASSOCIATED, this.newItemAssociatedEvent);
    }
    entityChanged(key, newValue, oldValue) {
        if (this.initialized && this.conditionalKeys.has(key)) {
            this.clearOutdatedAssociations(key);
        }
        this.updateStaticAssociationsOnDataChange();
        //
        // If there is any specific field change listener on this item then we should invoke it here
        //
        Object.entries(this.fieldChangeEventHandlers).forEach(([fieldName, handler]) => {
            if (key === fieldName) {
                handler(newValue, oldValue);
            }
        });
    }
    isIncludedInAssociation(associationName) {
        return this.associatedValues[associationName]?.includes(this);
    }
    updateStaticAssociationsOnDataChange() {
        if (!this.cache || this.reverseAssociationCleanupRunning) {
            return;
        }
        const possibleAssociations = this.cache.getPossibleAssociations(this.constructor.getModelName(), this.data);
        Object.entries(possibleAssociations).forEach(([associationName, items]) => {
            items.forEach(item => {
                if (item.isIncludedInAssociation(associationName)) {
                    if (!item.itemMatchesAllConditions(this.data, item.constructor.allowedAssociations[associationName])) {
                        item.removeItemFromAssociation(associationName, this.data.id);
                    }
                }
                else if (item.itemMatchesAllConditions(this.data, item.constructor.allowedAssociations[associationName])) {
                    item.addNewAssociatedItem({
                        ...item.constructor.convertItemToAssociatedValueItem({
                            item: this,
                            ItemConstructor: this.constructor,
                        }),
                        isSingle: item.constructor.allowedAssociations[associationName].single,
                        associationName,
                    });
                }
            });
        });
    }
    updateIdKeyInAssociatedValueItems(oldId, associationName, data) {
        const association = this.associatedValueItems[associationName];
        if (association && association[oldId]) {
            const associatedValue = Object.assign(association[oldId], data);
            this.associatedValueItems[associationName][oldId] = undefined;
            associatedValue.id = data.id;
            this.associatedValueItems[associationName][data.id] = associatedValue;
            this.getGeneratedAssociatedValueItems(associationName);
        }
    }
    clearOutdatedAssociations(fieldName) {
        const associations = this.collectAssociationsForFieldName(fieldName);
        Object.entries(associations)
            .filter(([associationName]) => this.associatedValues[associationName])
            .forEach(([associationName, association]) => {
            this.clearOutdatedItemsFromAssociation(associationName, association);
        });
    }
    clearOutdatedItemsFromAssociation(associationName, association) {
        let cleaned = false;
        this.associatedValues[associationName].forEach(associatedItem => {
            if (!this.itemMatchesAllConditions(associatedItem, association)) {
                cleaned = true;
                this.removeItemFromAssociation(associationName, associatedItem.data.id);
                this.removeFromEventForwardingIfNeeded(associatedItem);
            }
        });
        if (cleaned) {
            this.getGeneratedAssociatedValueItems(associationName);
            this.resetAssociationLoading(associationName, association.key);
        }
    }
    removeFromEventForwardingIfNeeded(associatedItem) {
        if (!this.isAssociatedTo(associatedItem)) {
            this.removeFromEventForwarding(associatedItem);
        }
    }
    resetAssociationLoading(associationName, associationKey) {
        this.associatedValues[associationName] = undefined;
        this.resetAssociatedValueItems(associationName);
        this.loadedAssociationValuesKeys[associationKey] = undefined;
        this.associatedValueLoadingOptions[associationKey] = undefined;
    }
    resetAssociatedValueItems(associationName) {
        this.associatedValueItems[associationName] = undefined;
        this.getGeneratedAssociatedValueItems(associationName);
    }
    collectAssociationsForFieldName(fieldName) {
        return Object.entries(this.constructor.allowedAssociations)
            .reduce((associations, [associationName, association]) => {
            const { condition = {} } = association;
            if (this.isFieldPresentInCondition(condition, fieldName)) {
                associations[associationName] = association;
            }
            return associations;
        }, {});
    }
    isFieldPresentInCondition(condition, fieldName) {
        return Object.values(condition).some(conditionKey => this.constructor.Entity.fieldSymbolValues[conditionKey] === fieldName);
    }
    removeAssociationLinks(association, itemToDelete) {
        //
        // Link should only be removed (foreign key reset to undefined) if the itemToDelete matches all conditions
        // of the association
        // Also we don't need to unset the linking if the parent is also deleted or association is not single, unless the item is still unsaved
        //
        const doesMatchAllConditions = this.itemMatchesAllConditions(itemToDelete.data, association);
        if ((!this.isDeleted || itemToDelete.isNewItem()) && doesMatchAllConditions && association.single) {
            Object.entries(association.condition || {}).forEach(([conditionKey, conditionValue]) => {
                if (typeof conditionValue === 'symbol' && this.data[this.constructor.Entity.fieldSymbolValues[conditionValue]] === itemToDelete.data[conditionKey]) {
                    if (Object.values(this.constructor.Entity.getForeignFieldSymbols()).includes(conditionValue)) {
                        this.data[this.constructor.Entity.fieldSymbolValues[conditionValue]] = undefined;
                    }
                }
            });
        }
    }
    addAssociationToCache(associationName) {
        if (this.cache) {
            this.cache.updateAssociationMap(this, this.constructor.allowedAssociations[associationName], associationName);
        }
    }
    addToCache(item) {
        if (this.cache) {
            this.cache.add(item);
        }
    }
    removeFromCache() {
        if (this.cache) {
            this.cache.remove(this);
        }
    }
    updateIdInCache(item) {
        if (this.cache) {
            this.cache.updateId(item);
        }
    }
    update(sourceItem) {
        this.data.suppressEvents();
        Object.assign(this.data, sourceItem.data);
        this.data.unSuppressEvents();
    }
    /**
     * Create a new associated item with the given parameters. Any addition to the associatedValues object
     * must be done via this function.
     *
     * @param {string} associationName
     * @param {Function} ItemConstructor
     * @param {DataObject | ComplexData} item
     * @param {DataObject} extraData
     * @param {boolean} isSingle
     * @param {boolean} fromBuilder
     * @returns {number}
     */
    addNewAssociatedItem({ associationName, ItemConstructor, item, extraData = this.extraData, isSingle, }, fromBuilder = false) {
        const association = this.constructor.allowedAssociations[associationName];
        if (isSingle || association.single !== undefined ? association.single : false) {
            this.removePreviousItemFromSingleAssociation(associationName, item.id || (item.data && item.data.id));
        }
        let itemCopy = item[itemIsInstantiatedSymbol] ? item : { ...item };
        itemCopy[constructorSymbol] = ItemConstructor;
        baseData_1.default.createIdSymbol(itemCopy);
        /**
         * if we pass an item without an id and that item found in extraData then we should keep track the generated id there. If we don't do this
         * then different getters will reuse the same item in extraData for different associations, which otherwise should return the same instance.
         */
        if (!(item instanceof ComplexData) && !(itemCopy instanceof ComplexData) && this.isItemInExtraData(item)) {
            item.id = itemCopy.id;
        }
        this.extendExtraDataWithSelf(extraData);
        this.buildAssociations(associationName, itemCopy, extraData);
        if (itemCopy[itemIsInstantiatedSymbol]) {
            this.setupEventForwarding(itemCopy[instanceSymbol]);
            this.addToCache(itemCopy[instanceSymbol]);
            if (!itemCopy[instanceSymbol].proxyMapKey) {
                itemCopy[instanceSymbol].proxyMapKey = Symbol('proxyMapKey');
            }
            this.proxyMap[itemCopy[instanceSymbol].proxyMapKey] = item;
        }
        if (this.cache && this.cache.constructor.isCacheable(association)) {
            // @ts-ignore ts-fix-issues
            this.cache.reverseAssociations.add(this, ItemConstructor.getModelName(), itemCopy.id);
        }
        // @ts-ignore ts-fix-issues
        let returnId = itemCopy.id;
        if (item[isUpdatedSymbol] || item[isDeletedSymbol]) {
            //
            // Make sure the item is instantiated
            //
            itemCopy = this.cacheItemInstance(itemCopy, () => extraData);
            if (item[isUpdatedSymbol]) {
                itemCopy.data.setDirty();
            }
            if (item[isDeletedSymbol]) {
                this.deletedItemsHolderForClone.push(itemCopy);
            }
            returnId = itemCopy.data.id;
        }
        // @ts-ignore ts-fix-issues
        if (typeof itemCopy.id === 'symbol') {
            this.emit(ComplexData.EVENTS.NEW_ITEM_ADDED, { item: itemCopy });
        }
        if (fromBuilder) {
            this.loadedAssociationValuesKeys[associationName] = true;
        }
        return returnId;
    }
    removePreviousItemFromSingleAssociation(associationName, newItemId) {
        if (!this.associatedValueItems[associationName]) {
            return;
        }
        const associatedItems = (0, object_1.getValuesIncludingSymbolProperties)(this.associatedValueItems[associationName], [valuesAsArrayKey]);
        const previousItem = associatedItems[0] && associatedItems[0][instanceSymbol];
        if (previousItem && previousItem.data.id !== newItemId) {
            this.unlinkAssociatedItem(associationName, previousItem);
            const reverseAssociations = previousItem.constructor.allowedAssociationsByConstructor.get(this.constructor);
            reverseAssociations.forEach(([reverseAssociationName]) => {
                if (this.isAssociatedTo(previousItem)) {
                    previousItem.unlinkAssociatedItem(reverseAssociationName, this);
                }
            });
        }
    }
    isAssociatedTo(instance) {
        return Object.entries(instance.constructor.allowedAssociations)
            .filter(([, association]) => association.instance === this.constructor)
            .some(([key]) => instance.associatedValueItems[key] && instance.associatedValueItems[key][this.data.id]);
    }
    buildAssociations(associationName, itemCopy, extraData) {
        this.addToAllPossibleAssociations(associationName, itemCopy, extraData);
    }
    extendExtraDataWithSelf(extraData) {
        extraData[this.constructor.associationKey] = extraData[this.constructor.associationKey] || [];
        const data = this.data.getDataValues();
        if (!extraData[this.constructor.associationKey].some(item => item.id === data.id)) {
            extraData[this.constructor.associationKey].push(data);
        }
    }
    addToAllPossibleAssociations(mainAssociationName, itemCopy, extraData) {
        let savedAtLeastOnce = false;
        this.getAllPossibleAssociations(mainAssociationName, itemCopy)
            .forEach(([associationName, association]) => {
            const savedToAssociation = this.saveItemAndUpdateProxy(associationName, association, itemCopy, extraData);
            savedAtLeastOnce = savedAtLeastOnce || savedToAssociation;
        });
        if (savedAtLeastOnce) {
            this.emit(ComplexData.EVENTS.NEW_ITEM_ASSOCIATED, {
                itemCopy,
                extraData,
                associationKey: this.constructor.allowedAssociations[mainAssociationName].key,
            });
        }
    }
    saveItemAndUpdateProxy(associationName, association, itemCopy, extraData) {
        const saved = this.saveItemToAssociatedValueItems(associationName, association.single !== undefined ? association.single : false, itemCopy);
        if (saved) {
            this.associatedValues[associationName] = this.associatedValues[associationName] || this.createProxy(associationName, extraData);
            this.validateAndSetDefaults(associationName, itemCopy[itemIsInstantiatedSymbol] ? itemCopy[instanceSymbol].data : itemCopy, association.single !== undefined ? association.single : false);
        }
        return saved;
    }
    getAllPossibleAssociations(mainAssociationName, itemCopy) {
        return this.getAssociationsForSameModel(mainAssociationName)
            .filter(([associationName, association]) => associationName === mainAssociationName || this.itemMatchesAllConditions(itemCopy, association));
    }
    getAssociationsForSameModel(associationName) {
        return Object.entries(this.constructor.allowedAssociations)
            .filter(([_key, value]) => value.instance === this.constructor.allowedAssociations[associationName].instance);
    }
    /**
     * @deprecated
     * Please refer to `allowedAssociationsByConstructor` as a faster alternative.
     * @param constructor
     * @private
     */
    getAssociationsForSameConstructor(constructor) {
        return Object.entries(this.constructor.allowedAssociations)
            .reduce((associations, [key, value]) => {
            if (value.instance === constructor) {
                associations[key] = value;
            }
            return associations;
        }, {});
    }
    saveItemToAssociatedValueItems(associationName, isSingle, itemCopy) {
        this.associatedValueItems[associationName] = this.getGeneratedAssociatedValueItemsObject(associationName);
        if (this.associatedValueItems[associationName][itemCopy.id]) {
            return false;
        }
        if (isSingle) {
            const key = Reflect.ownKeys(this.associatedValueItems[associationName]).filter(filterKey => filterKey !== valuesAsArrayKey);
            delete this.associatedValueItems[associationName][key[0]];
        }
        this.associatedValueItems[associationName][itemCopy.id] = itemCopy;
        this.getGeneratedAssociatedValueItems(associationName);
        return true;
    }
    getGeneratedAssociatedValueItemsObject(associationName) {
        if (!this.associatedValueItems[associationName]) {
            this.addAssociationToCache(associationName);
            this.associatedValueItems[associationName] = { [valuesAsArrayKey]: [] };
        }
        return this.associatedValueItems[associationName];
    }
    async delete() {
        /**
         * We still have associations without complex data implementations, which is problematic
         * with some recent change, as we would try to instantiate a non-existing complex data model before
         * deletion.
         */
        if (!this.isNewItem() && this.forwardedEventsRoot[ComplexData.EVENTS.ITEM_DELETED] && this.forwardedEventsRoot[ComplexData.EVENTS.ITEM_DELETED].getAssociatedItemSet(true).has(this)) {
            this.forwardedEventsRoot[ComplexData.EVENTS.ITEM_DELETED].deletedAssociatedItems.push(this);
        }
        this.privateDeleted = true;
        const cascadeDeleteAssociations = Object.entries(this.constructor.allowedAssociations)
            .filter(([_associationKey, associationValue]) => associationValue.cascadeDelete && associationValue.instance);
        await Promise.all(cascadeDeleteAssociations.map(async ([associationName]) => {
            const associatedValue = await this.getAssociatedValue(associationName);
            if (associatedValue) {
                return bluebird_1.default.map(associatedValue, async (associatedItem) => {
                    if (this.deletedAssociatedItems.indexOf(associatedItem) < 0 && !associatedItem.isNewItem()) {
                        this.deletedAssociatedItems.push(associatedItem);
                    }
                    if (!associatedItem.isDeleted) {
                        await associatedItem.delete();
                    }
                });
            }
            this.getGeneratedAssociatedValueItems(associationName);
            return null;
        }));
        this.emit(ComplexData.EVENTS.ITEM_DELETED, { item: this });
        this.removeFromCache();
        return null;
    }
    async removeAssociatedItem(options) {
        const { associationName, item, isSingle } = options;
        let associatedItem = item && item[instanceSymbol];
        if (!associatedItem) {
            associatedItem = isSingle ? (await this.getAssociatedValue(associationName))[0] : await this.getAssociatedValueById(associationName, item.id);
        }
        if (this.constructor.allowedAssociations[associationName].cascadeDelete) {
            await associatedItem.delete();
        }
        this.unlinkAssociatedItem(associationName, associatedItem);
        return associatedItem;
    }
    unlinkAssociatedItem(associationName, associatedItem) {
        associatedItem.reverseAssociations.delete(this);
        this.removeAssociationLinks(this.constructor.allowedAssociations[associationName], associatedItem);
        const associatedItemId = associatedItem.getData().id;
        this.removeFromAllAssociations(associatedItem, associatedItemId);
        this.getGeneratedAssociatedValueItems(associationName);
        this.removeFromEventForwardingIfNeeded(associatedItem);
    }
    removeFromAllAssociations(associatedItem, associatedItemId) {
        Object.entries(this.constructor.allowedAssociations)
            .filter(([, association]) => association.instance === associatedItem.constructor)
            .forEach(([associationName]) => {
            this.removeItemFromAssociation(associationName, associatedItemId);
        });
    }
    removeFromReverseAssociations(associatedItem) {
        associatedItem.reverseAssociationCleanupRunning = true;
        Object.keys(associatedItem.getAssociationsForSameConstructor(this.constructor))
            .filter(associationName => Boolean(associatedItem.associatedValueItems[associationName] && associatedItem.associatedValueItems[associationName][this.data.id]))
            .forEach(associationName => {
            associatedItem.unlinkAssociatedItem(associationName, this);
            associatedItem.noticeAssociationChange(associationName);
        });
        associatedItem.reverseAssociationCleanupRunning = false;
    }
    removeDeletedAssociation(associatedItemConstructor, id) {
        const deletedItemIndex = this.deletedAssociatedItems.findIndex(deletedItem => deletedItem.constructor === associatedItemConstructor
            && deletedItem.data.id === id);
        if (deletedItemIndex !== -1) {
            this.deletedAssociatedItems.splice(deletedItemIndex, 1);
        }
    }
    removeItemFromAssociation(associationName, associatedItemId) {
        if (this.associatedValueItems[associationName]) {
            delete this.associatedValueItems[associationName][associatedItemId];
            _.remove(this.associatedValueItems[associationName][valuesAsArrayKey], { id: associatedItemId });
        }
    }
    validateAndSetDefaults(associationName, item, isSingle) {
        const association = this.constructor.allowedAssociations[associationName];
        if (typeof association !== 'undefined') {
            Reflect.ownKeys(association.condition || {}).map(key => [key, association.condition[key]]).forEach(([key, value]) => {
                if (isSingle) {
                    if (typeof value === 'symbol') {
                        if (Object.values(this.constructor.Entity.getForeignFieldSymbols()).includes(value)) {
                            this.data[this.constructor.Entity.fieldSymbolValues[value]] = item[key];
                        }
                        else {
                            item[key] = this.data[this.constructor.Entity.fieldSymbolValues[value]];
                        }
                    }
                    if (typeof key === 'symbol') {
                        if (Object.values(this.constructor.Entity.getFieldSymbols()).includes(key)) {
                            // @ts-ignore
                            this.data[this.constructor.Entity.fieldSymbolValues[key]] = value;
                        }
                        else {
                            throw Object.assign(new Error('Condition symbol key cannot be found in entity\'s fieldSymbolValus'), {
                                details: {
                                    conditions: association.condition,
                                    key,
                                    item,
                                },
                            });
                        }
                    }
                }
                item[key] = this.validateAgainstAssociationCondition(item, key, value);
            });
        }
    }
    validateAgainstAssociationCondition(item, key, value) {
        const newValue = this.getValueForCondition(value);
        if (key !== '$or'
            && typeof item[key] !== 'undefined'
            && item[key] !== newValue) {
            throw new exceptions.ValidationError({
                // String constructor is needed for Symbols
                message: `${String(key)} value is invalid as it is not matching the criteria defined in the allowedAssociations config. Value: ${String(item[key])}, Expected: ${String(newValue)}`,
            });
        }
        return newValue;
    }
    getValueForCondition(value) {
        return (typeof value === 'symbol') ? this.data[this.constructor.Entity.fieldSymbolValues[value]] : value;
    }
    async validate(params) {
        if (this.isDeleted) {
            return new validationResult_1.default();
        }
        //
        // Do validation of this object
        //
        const validationResult = await this.validateItem(params);
        //
        // Do validation of all non-deleted in-memory associated objects
        //
        const associatedItems = this.getChangedItems();
        await Promise.all([...associatedItems].map(async (associatedItem) => {
            if (!associatedItem.isDeleted && !this.sameAsAssociatedItem(associatedItem)) {
                const itemValidationResult = await associatedItem.validateItem(params);
                validationResult.mergeWith(itemValidationResult);
            }
            return null;
        }));
        return validationResult;
    }
    sameAsAssociatedItem(associatedItem) {
        return this === associatedItem;
    }
    async validateItem(params) {
        const validationResult = new validationResult_1.default();
        const extra = (params && params.extra) || {};
        validationResult.mergeWith(await modelValidator_1.default.validate(this, this.constructor.modelDefinition, extra));
        const customRuleValidationResult = await this.validateCustomRules(params);
        validationResult.mergeWith(customRuleValidationResult);
        return validationResult;
    }
    async validateCustomRules(params) {
        return new validationResult_1.default();
    }
    /**
     * Save the item and any associations by using the resolver
     * passed in
     *
     * @param resolver
     */
    save(resolver) {
        if (this.disposable) {
            throw new DisposableComplexDataError('Cannot save disposable instances', this);
        }
        const saveResult = this.constructor.saveAll([this], resolver);
        this.deletedAssociatedItems = [];
        return saveResult;
    }
    static saveAll(complexDataObjects, resolver) {
        const items = complexDataObjects.reduce((collection, complexDataObject) => collection.concat(complexDataObject.getChangedItems()), []);
        return this.saveItems(items, resolver);
    }
    static async saveItems(items, resolver) {
        const itemsToSave = items.filter(item => {
            if (item.saving) {
                return false;
            }
            item.saving = true;
            item.initialId = item.data.id;
            item.data.mute();
            return true;
        });
        try {
            await resolver.resolve({ items: itemsToSave, rootNode: 'dataValues' });
            itemsToSave.forEach(item => {
                item.data.isChanged = false;
                if (item.data.id !== item.initialId) {
                    item.updateIdInCache(item);
                    item.reverseAssociations.forEach(associatedItem => associatedItem.emit(ComplexData.EVENTS.ID_UPDATED, { item }));
                    item.emit(ComplexData.EVENTS.FIELD_CHANGED, {
                        key: 'id',
                        newValue: item.data.id,
                        oldValue: item.initialId,
                        item,
                    });
                }
            });
        }
        finally {
            itemsToSave.forEach(item => {
                item.saving = false;
                item.data.unmute();
                item.emit(ComplexData.EVENTS.SAVED, { item });
            });
        }
    }
    getChangedItems() {
        const collectedSet = new Set();
        [...this.getDeepAssociatedItems(), this].forEach(item => {
            collectedSet.add(item);
        });
        return [...collectedSet]
            .filter(item => (item && (0, ts_mixer_1.hasMixin)(item, ComplexData)) && (item.isUpdated || item.isNew || item.isDeleted));
    }
    getDeepAssociatedItems(includeNonInstantiated = false) {
        const collected = new Set();
        const processed = new Set();
        this.collectDeepAssociatedItems({ collected, processed, includeNonInstantiated });
        return collected;
    }
    collectDeepAssociatedItems({ collected, processed, includeNonInstantiated, }) {
        processed.add(this);
        const associatedItems = [...this.getAssociatedItemSet(includeNonInstantiated), ...this.deletedAssociatedItems];
        associatedItems.forEach(item => {
            collected.add(item);
            (item.deletedAssociatedItems || []).forEach(deletedAssociatedItem => {
                collected.add(deletedAssociatedItem);
            });
            if (!processed.has(item) && item.collectDeepAssociatedItems) {
                item.collectDeepAssociatedItems({ collected, processed, includeNonInstantiated });
            }
        });
    }
    /**
     * Get the associated items as a new Set
     *
     * @returns {Set<*>}
     */
    getAssociatedItemSet(includeNonInstantiated) {
        return Object.entries(this.associatedValueItems).reduce((accumulatedItems, [_key, items]) => new Set([
            ...accumulatedItems,
            ...items[valuesAsArrayKey]
                .reduce((instances, item) => {
                if (item[instanceSymbol]) {
                    instances.push(item[instanceSymbol]);
                }
                else if (includeNonInstantiated) {
                    instances.push(item);
                }
                return instances;
            }, []),
        ]), new Set());
    }
    /**
     * Clones the current object
     *
     * @returns {ComplexData}
     */
    async clone(instantiatedClones = {}, parent = null) {
        const clonedObject = await this.createClonedObject(parent);
        this.rememberClonedInstance(clonedObject, instantiatedClones);
        await this.cloneAssociations(instantiatedClones, clonedObject);
        await this.cloneDeletedAssociations(instantiatedClones, clonedObject);
        this.updateClonedAssociations(clonedObject);
        this.cloneLoadingOptions(clonedObject);
        return clonedObject;
    }
    cloneLoadingOptions(clonedObject) {
        clonedObject.associatedValueLoadingOptions = _.cloneDeep(this.associatedValueLoadingOptions);
    }
    /**
     * Update associatedValues by creating new proxies for it.
     *
     * @param {ComplexData} clonedObject
     */
    updateClonedAssociations(clonedObject) {
        Object.keys(this.constructor.allowedAssociations)
            .filter(associationName => this.associatedValues[associationName])
            .forEach(associationName => {
            clonedObject.associatedValues[associationName] = clonedObject.createProxy(associationName);
        });
    }
    /**
     * Clone all deleted associations for the clonedObject
     *
     * @param {{}} instantiatedClones
     * @param {ComplexData} clonedObject
     * @returns {Promise<void>}
     */
    async cloneDeletedAssociations(instantiatedClones, clonedObject) {
        await bluebird_1.default.each(this.deletedAssociatedItems, async (item) => {
            const { id } = item.data;
            const key = item.constructor.associationKey;
            instantiatedClones[key] = instantiatedClones[key] || {};
            let clonedInstance = instantiatedClones[key][id];
            if (!clonedInstance) {
                clonedInstance = await item.clone(instantiatedClones, clonedObject);
            }
            if (!clonedObject.deletedAssociatedItems.includes(clonedInstance)) {
                clonedObject.deletedAssociatedItems.push(clonedInstance);
            }
        });
    }
    /**
     * Clone all associations for the clonedObject
     *
     * @param {{}} instantiatedClones
     * @param {ComplexData} clonedObject
     * @returns {Promise<void>}
     */
    async cloneAssociations(instantiatedClones, clonedObject) {
        await bluebird_1.default.each(Object.entries(this.associatedValueItems), async ([associationName, items]) => {
            const associationKey = this.constructor.allowedAssociations[associationName].key;
            instantiatedClones[associationKey] = instantiatedClones[associationKey] || {};
            clonedObject.associatedValueItems[associationName] = clonedObject.getGeneratedAssociatedValueItemsObject(associationName);
            await bluebird_1.default.each((0, object_1.entriesWithSymbols)(items, [valuesAsArrayKey]), async ([id, item]) => {
                if (!item) {
                    return;
                }
                const clonedItem = { ...item };
                if (item[itemIsInstantiatedSymbol]) {
                    let clonedInstance = instantiatedClones[associationKey][id];
                    if (!clonedInstance) {
                        clonedInstance = await item[instanceSymbol].clone(instantiatedClones, clonedObject);
                    }
                    clonedItem[itemIsInstantiatedSymbol] = true;
                    clonedItem[instanceSymbol] = clonedInstance;
                }
                if (clonedObject.cache) {
                    clonedObject.cache.reverseAssociations.add(clonedObject, clonedItem[constructorSymbol].getModelName(), id);
                }
                clonedObject.associatedValueItems[associationName][id] = clonedItem;
            });
        });
    }
    /**
     * Save cloned object to instantiatedClones to avoid cloning it again.
     *
     * @param {ComplexData} clonedObject
     * @param {{}} instantiatedClones
     */
    rememberClonedInstance(clonedObject, instantiatedClones) {
        const { id } = clonedObject.data;
        const key = clonedObject.constructor.associationKey;
        instantiatedClones[key] = instantiatedClones[key] || {};
        instantiatedClones[key][id] = clonedObject;
    }
    /**
     * Clone single object without associations
     *
     * @param {ComplexData} parent
     * @returns {Promise<ComplexData>}
     */
    async createClonedObject(parent = null) {
        const clonedObject = await this.constructor.build(this.getDataWithState(), { [skipDefaultsSymbol]: true }, {
            parent,
            listeners: !parent ? this.getRootListenerMap(baseData_1.default.EXTERNAL_EVENTS) : {},
            cache: parent ? parent.cache : new (this.cache ? this.cache.constructor : cache_1.default)(),
        });
        clonedObject.associatedValueItems = {};
        // @ts-ignore
        clonedObject.extraData[skipDefaultsSymbol] = null;
        return clonedObject;
    }
    async copyFrom(sourceItem) {
        return this.updateAllAssociatedValues(sourceItem);
    }
    getDataWithState() {
        return {
            [constructorSymbol]: this.constructor,
            ...this.data.getDataValues(),
            ...(this.isNew ? { [isNewSymbol]: true } : {}),
            ...(this.isDeleted ? { [isDeletedSymbol]: true } : {}),
            ...(this.isUpdated ? { [isUpdatedSymbol]: true } : {}),
        };
    }
    getIdWithState() {
        return {
            [constructorSymbol]: this.constructor,
            id: this.dataValues.id,
            ...(this.isNew ? { [isNewSymbol]: true } : {}),
            ...(this.isDeleted ? { [isDeletedSymbol]: true } : {}),
            ...(this.isUpdated ? { [isUpdatedSymbol]: true } : {}),
        };
    }
    sameItemIncludedInDeletedAssociations(associationInstance) {
        return this.deletedAssociatedItems.some(deletedItem => deletedItem.constructor === associationInstance.constructor
            && deletedItem.data.id === associationInstance.data.id);
    }
    async updateAllAssociatedValues(clone, checkedValues = new uniqueIdStorage_1.default()) {
        this.update(clone);
        const associatedValues = Object.entries(clone.associatedValues).filter(([, items]) => Boolean(items));
        await bluebird_1.default.each(associatedValues, (async ([associationName, items]) => {
            const association = this.constructor.allowedAssociations[associationName];
            if (items && this.associatedValues[associationName]) {
                await bluebird_1.default.each(this.associatedValues[associationName], (async (associationInstance) => {
                    if (clone.sameItemIncludedInDeletedAssociations(associationInstance)) {
                        await associationInstance.delete();
                        if (!checkedValues.has(associationInstance)) {
                            checkedValues.add(associationInstance);
                        }
                    }
                }));
            }
            await bluebird_1.default.each(items, (async (sourceItem) => {
                const instance = this.createItemInstance(sourceItem.getDataWithState(), {});
                if (association.instance === instance.constructor) {
                    this.updateItemInAssociation(associationName, sourceItem, instance);
                }
                if (!checkedValues.has(instance)) {
                    checkedValues.add(instance);
                    await instance.updateAllAssociatedValues(sourceItem, checkedValues);
                }
            }));
        }));
    }
    updateItemInAssociation(associationName, sourceItem, instance) {
        const associatedItem = this.associatedValueItems[associationName] && this.associatedValueItems[associationName][sourceItem.data.id];
        if (!associatedItem) {
            const isSingle = this.constructor.allowedAssociations[associationName].single !== undefined
                ? this.constructor.allowedAssociations[associationName].single
                : false;
            this.addNewAssociatedItem({
                associationName,
                ...this.constructor.convertItemToAssociatedValueItem({
                    item: instance,
                    ItemConstructor: sourceItem.constructor,
                }),
                isSingle,
            });
            this.noticeAssociationChange(associationName);
        }
    }
    async addAssociationIfMatchesConditions(associationName, data) {
        const association = this.constructor.allowedAssociations[associationName];
        if (!this.itemMatchesAllConditions(data, association)) {
            return;
        }
        this.removeDeletedAssociation(association.instance, data.id);
        await this[`${association.single ? 'set' : 'add'}${this.constructor.getMethodName(associationName, association, false)}`](data);
    }
    /**
     * addNewAssociatedItem and removeAssociatedItems functions can take either a ComplexData
     * instance or an object as their 'item' argument. This function is used to detect
     * which type is passed in and convert to the appropriate format.
     *
     * @param {DataObject | ComplexData} item
     * @param {Function} ItemConstructor
     */
    static convertItemToAssociatedValueItem({ item, ItemConstructor, }) {
        if (!item || !(0, ts_mixer_1.hasMixin)(item, ComplexData)) {
            return { item, ItemConstructor };
        }
        if (!(item instanceof ItemConstructor)) {
            throw new TypeError(`Type mismatch, ${item.constructor.name} should be a(n) ${ItemConstructor.getModelName()}`);
        }
        return {
            ItemConstructor,
            item: {
                ...item.data.getDataValues(),
                [instanceSymbol]: item,
                [itemIsInstantiatedSymbol]: true,
            },
        };
    }
    async getSearchableFields() {
        return [];
    }
    async copyData(_from) {
        return this;
    }
    getConditionalKeysBetweenTwoComplexData(complex1, complex2) {
        return Object.values(complex1.constructor.allowedAssociations)
            .filter(item => item.instance === complex2.constructor)
            .reduce((acc, item) => [...acc, ...Object.keys(item.condition)], []);
    }
    getConditionalKeysToRemove(complex1, complex2) {
        return [
            ...this.getConditionalKeysBetweenTwoComplexData(complex1, complex2),
            ...this.getConditionalKeysBetweenTwoComplexData(complex2, complex1),
        ];
    }
    async deepCopy({ walkMap, newProperties, parent }) {
        const processedItems = [];
        let copyRootItem;
        const newItems = [];
        const idMap = {};
        await (0, assiciationWalker_1.default)({
            walkMap,
            actualRecord: this,
            callback: async (record, parentRecord, args) => {
                let newItem;
                const complexParent = args.newItem || args.job;
                const associations = Object.entries(complexParent.constructor.allowedAssociations).filter(([key, association]) => association.instance === record.constructor);
                const filteredNewProperties = Object.fromEntries(Object.entries(newProperties).filter(([key]) => record.constructor.Entity.hasField(key)));
                await bluebird_1.default.each(associations, async ([associationName, association]) => {
                    const processedId = `${association.key}:${record.data.id.toString()}`;
                    if (!processedItems.includes(processedId)) {
                        const keysToReset = this.getConditionalKeysToRemove(parentRecord, record);
                        const resetObject = Object.fromEntries(keysToReset.map(key => [key, undefined]));
                        const withoutId = {
                            ...record.data.getPureDataValues(),
                            ...filteredNewProperties,
                            ...resetObject,
                        };
                        delete withoutId.id;
                        const id = complexParent.addNewAssociatedItem({
                            ...complexParent.constructor.convertItemToAssociatedValueItem({
                                item: withoutId,
                                ItemConstructor: record.constructor,
                            }),
                            isSingle: association.single,
                            associationName,
                        });
                        complexParent.markAssociationLoaded(associationName, {});
                        newItem = await complexParent.getAssociatedValueById(associationName, id);
                        newItems.push(newItem);
                        Object.entries(record.constructor.allowedAssociations).forEach(([name, associationConfig]) => {
                            Object.entries(associationConfig.condition).forEach(([key, value]) => {
                                const oldValue = record.getValueForCondition(value);
                                const newValue = newItem.getValueForCondition(value);
                                if (oldValue !== newValue) {
                                    const originalValueWithPrefixes = `${associationConfig.instance.modelProperties.modelName}:${key}:${oldValue.toString()}`;
                                    idMap[originalValueWithPrefixes] = newValue;
                                }
                            });
                        });
                        copyRootItem = copyRootItem || newItem;
                        processedItems.push(processedId);
                    }
                });
                return { success: true, job: args.job, newItem };
            },
            associatedRecordGetter: async (complexItem, association) => complexItem.getAssociatedValue(association.key),
            parentRecord: parent,
            optionalArgs: {
                job: parent,
            },
        });
        newItems.forEach(item => {
            item.conditionalKeys.forEach((key) => {
                if (item.data[key] !== undefined) {
                    const itemKeyInIdMap = `${item.constructor.modelProperties.modelName}:${String(key)}:${item.data[key].toString()}`;
                    if (idMap[itemKeyInIdMap] && item.data[key] !== idMap[itemKeyInIdMap]) {
                        item.data[key] = idMap[itemKeyInIdMap];
                    }
                }
            });
        });
        return copyRootItem;
    }
    /**
     * Definition of class methods automatically created for all associations
     *
     * @returns {[null,null]}
     */
    static getAssociationMethodDefinitions() {
        return [{
                prefix: 'addAll',
                isPlural: true,
                isSingle: false,
                handler({ ItemConstructor, associationName, isSingle, }, items, extraData = {}) {
                    if (!Array.isArray(items)) {
                        throw new TypeError('Argument must be an array');
                    }
                    const ids = items.map(item => this.addNewAssociatedItem({
                        ...this.constructor.convertItemToAssociatedValueItem({ item, ItemConstructor }),
                        associationName,
                        isSingle,
                        extraData,
                    }));
                    const options = {
                        filter: ids.map(id => ({
                            operator: '=',
                            property: 'id',
                            value: id,
                        })),
                    };
                    this.markAssociationLoaded(associationName, options);
                    return this.getAssociatedValue(associationName, options).filter(item => ids.includes(item.data.id));
                },
            }, {
                prefix: 'add',
                isPlural: false,
                isSingle: false,
                handler({ ItemConstructor, associationName, isSingle }, item, extraData = {}) {
                    const id = this.addNewAssociatedItem({
                        ...this.constructor.convertItemToAssociatedValueItem({ item, ItemConstructor }),
                        associationName,
                        isSingle,
                        extraData,
                    });
                    const options = {
                        filter: [{
                                operator: '=',
                                property: 'id',
                                value: id,
                            }],
                    };
                    const associatedValuesKey = this.constructor.allowedAssociations[associationName].key;
                    this.markAssociationLoaded(associatedValuesKey, options);
                    return this.getAssociatedValueById(associationName, id, options);
                },
            }, {
                prefix: 'remove',
                isPlural: false,
                isSingle: false,
                handler({ ItemConstructor, associationName, isSingle }, item, extraData = {}) {
                    return this.removeAssociatedItem({
                        ...this.constructor.convertItemToAssociatedValueItem({ item, ItemConstructor }),
                        associationName,
                        isSingle,
                        extraData,
                    });
                },
            }, {
                prefix: 'set',
                isPlural: false,
                isSingle: true,
                handler({ ItemConstructor, associationName, isSingle }, item, extraData = {}) {
                    if (item.isDeleted) {
                        console.log('Cannot set deleted item as association');
                        throw new Error('Cannot set an item that is marked as deleted');
                    }
                    const id = this.addNewAssociatedItem({
                        ...this.constructor.convertItemToAssociatedValueItem({ item, ItemConstructor }),
                        associationName,
                        isSingle,
                        extraData,
                    });
                    const options = {
                        filter: [{
                                operator: '=',
                                property: 'id',
                                value: id,
                            }],
                    };
                    const associatedValuesKey = this.constructor.allowedAssociations[associationName].key;
                    this.markAssociationLoaded(associatedValuesKey, options);
                    const associatedValues = this.getAssociatedValue(associationName, options);
                    if (associatedValues instanceof Promise || associatedValues.then) {
                        return associatedValues.then(result => result[0]);
                    }
                    return associatedValues[0];
                },
            }, {
                prefix: 'unset',
                isPlural: false,
                isSingle: true,
                handler({ ItemConstructor, associationName, isSingle }, item, extraData = {}) {
                    return this.removeAssociatedItem({
                        ...this.constructor.convertItemToAssociatedValueItem({ item, ItemConstructor }),
                        associationName,
                        isSingle,
                        extraData,
                    });
                },
            }, {
                prefix: 'get',
                isPlural: false,
                isSingle: true,
                async handler({ associationName }) {
                    const associatedValues = this.associatedValues[associationName] || await this.getAssociatedValue(associationName);
                    if (this.disposable) {
                        const Constructor = this.constructor.allowedAssociations[associationName].instance;
                        const newItemInstance = associatedValues[0] ? new Constructor(associatedValues[0], {}, {
                            parent: this,
                            disposable: true,
                            cache: this.cache,
                        }) : null;
                        if (newItemInstance) {
                            this.setupEventForwarding(newItemInstance);
                        }
                        return newItemInstance;
                    }
                    return associatedValues[0] || null;
                },
            }, {
                prefix: 'get',
                isPlural: false,
                isSingle: false,
                async handler({ associationName }, index) {
                    const associatedValues = await this.getAssociatedValue(associationName);
                    if (this.disposable && associatedValues[index]) {
                        const Constructor = this.constructor.allowedAssociations[associationName].instance;
                        const newItemInstance = new Constructor(associatedValues[index], {}, {
                            parent: this,
                            disposable: true,
                            cache: this.cache,
                        });
                        this.setupEventForwarding(newItemInstance);
                        return newItemInstance;
                    }
                    return associatedValues[index] || null;
                },
            }, {
                prefix: 'getAll',
                isPlural: true,
                isSingle: false,
                async handler({ associationName }, options = {}) {
                    const associatedValues = await this.getAssociatedValue(associationName, options);
                    if (this.disposable) {
                        const Constructor = this.constructor.allowedAssociations[associationName].instance;
                        return (associatedValues || []).map(value => {
                            const newItemInstance = new Constructor(value, {}, {
                                parent: this,
                                disposable: true,
                                cache: this.cache,
                            });
                            this.setupEventForwarding(newItemInstance);
                            return newItemInstance;
                        });
                    }
                    return associatedValues || [];
                },
            }, {
                prefix: 'get',
                postfix: 'ById',
                isPlural: false,
                isSingle: false,
                async handler({ associationName }, id) {
                    return this.getAssociatedValueById(associationName, id);
                },
            }, {
                prefix: 'get',
                postfix: 'Count',
                isPlural: false,
                isSingle: false,
                noInstanceNeeded: true,
                async handler({ associationName }, filters) {
                    return this.getAssociatedValueCount(associationName, filters);
                },
            }];
    }
}
ComplexData.associationsProcessed = false;
ComplexData.Entity = entity_1.EntityWithId;
ComplexData.valuesAsArrayKey = valuesAsArrayKey;
ComplexData.conditionalKeys = null;
ComplexData.runningBuildPromises = new Map();
exports.default = ComplexData;
__decorate([
    (0, decorators_1.memoizeRunningPromiseByKey)((associationName, options) => `${associationName}_${ComplexData.generateLoadOptionKey(options)}`),
    (0, decorators_1.setMemoizeByInstance)()
], ComplexData.prototype, "loadAssociatedValues", null);
__decorate([
    decorators_1.memoizeRunningPromise
], ComplexData, "searchByIndex", null);
__decorate([
    decorators_1.memoizeRunningPromise
], ComplexData, "callExternalFunction", null);
//# sourceMappingURL=../../src/complexData.js.map